export default "__VITE_PUBLIC_ASSET__d8dfaa57__"